import React from 'react'
import { Link } from 'react-router-dom'
function Navbar({score}) {
  const token = localStorage.getItem('token')
  const name = localStorage.getItem('name')

  return (
    <div style={{backgroundColor:'#1e81b0',height:60,display:'flex',alignItems:'flex-start',justifyContent:'space-around'}}>
    <div style={{marginLeft:80,display:'flex',alignItems:'flex-end',gap:50}}>
    <Link to={'/home'} style={{color:'white',fontSize:25,fontWeight:600,marginTop:10,textDecoration:'none'}}>Home</Link>
   {!token ?  <Link to={'/login'} href='' style={{color:'white',fontSize:25,fontWeight:600,marginTop:10,textDecoration:'none'}}>Login</Link> :''}
   {!token ?  <Link to={'/register'} href='' style={{color:'white',fontSize:25,fontWeight:600,marginTop:10,textDecoration:'none'}}>Register</Link> :''}

    </div>
    <div style={{display:'flex',gap:20}}>
        <h4 style={{color:'white'}}>Score: {score ? score : 0} </h4>
        <h4 style={{color:'white',textTransform:'capitalize'}}>{name}</h4>
    </div>
    </div>
  )
}

export default Navbar
